import React, { useEffect, useMemo, useState } from 'react';
import { deleteCategory, loadCategories } from 'cms/utils/Network';
import { BuildTalents } from 'cms/utils';
import CategoryContent from 'cms/pages/CategoryContent';
import CategoriesTopbarWidget from './categories/widgets/CategoriesTopbarWidget';
import CategoriesTableWidget from './categories/widgets/CategoriesTableWidget';
import './categories/categoriesMinimal.css';

export default function CategoriesContent({ id }) {
    const [loading, setLoading] = useState(0);
    const [show_delete, setShowDelete] = useState(false);
    const [categories, setCategories] = useState(null);

    const totalCount = useMemo(() => {
        if (!categories?.length) return 0;
        return categories.reduce((acc, parent) => acc + 1 + (parent.childs?.length || 0), 0);
    }, [categories]);

    const refreshCategories = () => {
        loadCategories().then((items) => {
            const parents = BuildTalents(items);
            setCategories(parents);
        });
    };

    useEffect(() => {
        refreshCategories();
    }, []);

    const handleDelete = (itemId) => {
        setLoading(itemId);
        deleteCategory(itemId).then(() => {
            refreshCategories();
            setLoading(0);
        });
    };

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete);
    };

    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;
        if (!destination) return;
        if (destination.index === source.index) return;
        if (!categories?.length) return;

        const draggedCategory = categories.find((x) => String(x.id) === String(draggableId));
        if (!draggedCategory) return;

        const next = [...categories];
        next.splice(source.index, 1);
        next.splice(destination.index, 0, draggedCategory);
        setCategories(next);
    };

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h3 className="box-title mb-10">
                        <span className="sr-only">Post Categories</span>
                    </h3>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/cms">
                                <i className="fa fa-dashboard"></i> Home
                            </a>
                        </li>
                        <li className="active">Post Categories</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row users-filter-page-row">
                            <div className="col-md-8 users-filter-page-col cms-categories-shell">
                                <div className="box talent-page-box">
                                    <CategoriesTopbarWidget
                                        totalCount={totalCount}
                                        showDelete={show_delete}
                                        onToggleDelete={showDelete}
                                    />
                                    <div className="box-body no-padding">
                                        <CategoriesTableWidget
                                            categories={categories}
                                            loadingId={loading}
                                            showDelete={show_delete}
                                            onDelete={handleDelete}
                                            onDragEnd={onDragEnd}
                                        />
                                    </div>
                                </div>
                            </div>
                            <CategoryContent id={id} />
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
